import {Component, ComponentFactoryResolver, ComponentRef, ElementRef, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {UrlService} from '../../services/url.service';
import {WebsiteBuilderService} from '../../services/website-builder.service';
import {WebsiteBuilderViewComponent} from './website-builder-view/website-builder-view.component';
import { environment } from '../../../environments/environment';
import { IWbThemeColors } from '../../types/api-response/auth/website-builder';


@Component({
    templateUrl: 'website-builder.component.html'
})
export class WebsiteBuilderComponent implements OnInit, OnDestroy {

    @ViewChild('webViewFrame') webViewFrame: ElementRef;
    frameWindow: Window;
    compRef: ComponentRef<WebsiteBuilderViewComponent>;

    constructor(public websiteBuilderService: WebsiteBuilderService,
                public urlService: UrlService,
                private vcRef: ViewContainerRef,
                private resolver: ComponentFactoryResolver
                ) {
    }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(() => {
            this.websiteBuilderService.showWebsiteBuilderView = false;
            this.websiteBuilderService.fullScreenPreview = false;
            this.websiteBuilderService.tabId = this.urlService.queryParams['tab'];
            this.websiteBuilderService.getCorporations(true);
        });
        this.urlService.setQueryParams('websiteBuilder');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.websiteBuilderService.resetData();
        this.urlService.resetQueryParams();

        if (this.compRef) {
            this.compRef.destroy();
        }
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    createComponent() {
        const compFactory = this.resolver.resolveComponentFactory(WebsiteBuilderViewComponent);
        this.compRef = this.vcRef.createComponent(compFactory);
        this.frameWindow.document.body.appendChild(this.compRef.location.nativeElement);
        this.websiteBuilderService.frameWindow = this.frameWindow;
        this.updateTheme();
    }

    onLoad() {
        setTimeout(_ => {
            this.frameWindow = this.webViewFrame.nativeElement.contentWindow;
            this.frameWindow.document.write(`<!DOCTYPE html>`);
            this.frameWindow.document.write(`<html>`);
            this.frameWindow.document.write(`<head>`);
            this.frameWindow.document.write(`<style id="themeStyle"></style>`);
            this.frameWindow.document.write(`<link rel="stylesheet" href="${environment.domainLanding}/bundles/landing/styles/style.css">`);
            this.frameWindow.document.write(`<style>.agm-map-container-inner {width: inherit; height: inherit;}</style>`);
            this.frameWindow.document.write(`</head>`);
            this.frameWindow.document.write(`<body></body>`);
            this.frameWindow.document.write(`</html>`);
            this.createComponent();
        });
    }

    turnFullscreenModeOff() {
        this.websiteBuilderService.fullScreenPreview = false;
        try {
            (<any>document.getElementsByClassName('navbar-static-top')[0]).style.display = 'block';
            (<any>document.getElementsByClassName('sidebar-menu')[0]).style.display = 'block';
            (<any>document.getElementsByClassName('zEWidget-launcher')[0]).style.display = 'block';
        } catch (e) {
            console.log(e);
        }
    }

    updateTheme(colors: IWbThemeColors = this.websiteBuilderService.data.data.themeColors) {
        const styleElement = this.frameWindow.document.getElementById('themeStyle');
        const cssVariables = Object.keys(colors).map(key => `--${key}: ${colors[key]};`).join('');
        styleElement.innerText = `:root {${cssVariables}}`;
    }

    canDeactivate() {
       return this.websiteBuilderService.deactivateSiteBuilderPage();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder.component.ts